<script>
import common from './common.vue';
export default {
  mixins: [common],
  data() {
    return {
      fanhuiIcon: `${this.$cdnLink}/wanXin/dhcl/back1.png`,
    }
  }
};
</script>

<style lang="scss" module>
@import "../../../assets/css/dhcl.scss";
.wrap {
  @include common-window();
  > header {
    position: relative;
    .fanhui {
      position: absolute;
      top: 0.45rem;
      left: 0.46rem;
      width: .35rem;
      height: .3rem;
    }
  }
  > main {
    position: relative;
    .coupon {
      position: absolute;
      top: .2rem;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 100;
      font-size: 0;
      border-radius: .2rem;
      overflow: hidden;
      :global {
        .yw-guanbi {
          position: absolute;
          top: .14rem;
          right: .18rem;
          font-size: .5rem;
        }
        .yw-xiangzuo {
          position: absolute;
          top: .22rem;
          left: .18rem;
          font-size: .36rem;
        }
      }
      .title {
        text-align: center;
        line-height: .8rem;
        border-top-left-radius: .1rem;
        border-top-right-radius: .1rem;
        font-size: .36rem;
      }
      .scrollWrap {
        height: 100%;
        overflow: hidden;
        color: #000000;
        .couponList {
          padding: .2rem .4rem .2rem .5rem;
          .couponItem {
            background: #EADCD0;
            color: #5F725C;
            border-radius: .14rem;
            margin-bottom: .14rem;
            padding: .2rem .12rem .2rem .22rem;
            display: flex;
            align-items: center;
            .selected {
              display: inline-block;
              width: .24rem;
              height: .24rem;
              border-radius: 50%;
              border: 1px solid #666666;
              box-sizing: border-box;
              margin-right: .22rem;
              &.active {
                position: relative;
                &:before {
                  position: absolute;
                  content: " ";
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                  background: #49b81d;
                  width: .12rem;
                  height: .12rem;
                  border-radius: 50%;
                }
              }
              &.disabled {
                position: relative;
                &:before {
                  position: absolute;
                  content: " ";
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                  background: #dfdfdf;
                  width: .12rem;
                  height: .12rem;
                  border-radius: 50%;
                }
              }
            }
            .major {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              .left {
                display: flex;
                align-items: center;
                text-align: left;
                .voucher {
                  width: .3rem;
                  height: .3rem;
                  margin-right: .12rem;
                }
                .name {
                  font-size: .26rem;
                  font-weight: 400;
                  margin-bottom: .1rem;
                }
                .condition {
                  display: flex;
                  align-items: center;
                  > img {
                    width: .14rem;
                    height: .14rem;
                    display: inline-block;
                    vertical-align: text-bottom;
                    margin-right: .04rem;
                  }
                  > span {
                    font-size: .16rem;
                    color: #ffffff;
                  }
                  .freeze {
                    color: #ff0000;
                  }
                }
              }
              .right {
                .discount {
                  font-size: .34rem;
                  color: #ff0000;
                  text-align: right;
                  margin-bottom: .12rem;
                  > span {
                    font-size: .26rem;
                  }
                }
                .deadline {
                  font-size: .16rem;
                  text-align: right;
                }
              }
            }
          }
        }
        .empty {
          box-sizing: border-box;
          padding-top: 15%;
          text-align: center;
          color: #9f9f9f;
          font-size: .22rem;
          > img {
            width: 1.18rem;
            height: .84rem;
            margin-bottom: .18rem;
          }
        }
      }
    }
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
      }
      .fanhui {
        position: absolute;
        top: 36px;
        right: 13px;
        width: 29px;
        height: 30px;
      }
    }
    > main {
      position: relative;
      .coupon {
        position: absolute;
        top: 10px;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 100;
        font-size: 0;
        border-radius: 10px;
        overflow: hidden;
        :global {
          .yw-guanbi {
            position: absolute;
            top: 7px;
            right: 9px;
            font-size: 25px;
          }
          .yw-xiangzuo {
            position: absolute;
            top: 11px;
            left: 9px;
            font-size: 18px;
          }
        }
        .title {
          text-align: center;
          line-height: 40px;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          font-size: 18px;
        }
        .scrollWrap {
          height: 100%;
          overflow: hidden;
          color: #000000;
          .couponList {
            padding: 10px;
            .couponItem {
              background: #27231b;
              border: 4.86px solid;
              border-image: linear-gradient(0deg, #130f0d 0%, #130f0d 8%, #371e14 50%, #130f0d 92%, #130f0d 100%) 7 7;
              box-shadow: 0px 3.47px 13.86px 0.17px rgba(5,0,0,0.75), 0px 0px 12.51px 0px rgba(255,161,82,0.30) inset; 
              color: #FFFFFF;
              border-radius: 7px;
              margin-bottom: 7px;
              padding: 10px 6px 10px 11px;
              display: flex;
              align-items: center;
              .selected {
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                border: 1px solid #666666;
                box-sizing: border-box;
                margin-right: 11px;
                &.active {
                  position: relative;
                  &:before {
                    position: absolute;
                    content: " ";
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    background: #49b81d;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                  }
                }
                &.disabled {
                  position: relative;
                  &:before {
                    position: absolute;
                    content: " ";
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    background: #dfdfdf;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                  }
                }
              }
              .major {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                .left {
                  display: flex;
                  align-items: center;
                  text-align: left;
                  .voucher {
                    width: 15px;
                    height: 15px;
                    margin-right: 6px;
                  }
                  .name {
                    font-size: 13px;
                    font-weight: 400;
                    margin-bottom: 5px;
                  }
                  .condition {
                    display: flex;
                    align-items: center;
                    > img {
                      width: 7px;
                      height: 7px;
                      display: inline-block;
                      vertical-align: text-bottom;
                      margin-right: 2px;
                    }
                    > span {
                      font-size: 8px;
                      color: #666666;
                    }
                  }
                }
                .right {
                  .discount {
                    font-size: 17px;
                    color: #ff0000;
                    text-align: right;
                    margin-bottom: 6px;
                    > span {
                      font-size: 13px;
                    }
                  }
                  .deadline {
                    font-size: 8px;
                    text-align: right;
                  }
                }
              }
            }
          }
          .empty {
            box-sizing: border-box;
            padding-top: 15%;
            text-align: center;
            color: #9f9f9f;
            font-size: 11px;
            > img {
              width: 59px;
              height: 42px;
              margin-bottom: 9px;
            }
          }
        }
      }
    }
  }
}
</style>